import { useCallback } from "react";
import { useRecordContext } from "react-admin";
import { type Schema } from "@pdfme/common";
import { DialogProps } from "../../misc/DialogProps";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { type DrivingLicenseAuthorityForm } from "../../providers/drivingLicenseAuthorityFormsProvider";
import { PdfMeTemplateDialog } from "../../misc/PdfMeTemplateDialog";

export function DrivingLicenseAuthorityFormTemplateDialog(props: DialogProps) {
  const dialogProps = props;
  const drivingLicenseAuthorityForm = useRecordContext<DrivingLicenseAuthorityForm>();

  const onSubmit = useCallback(
    async (pdfTemplate: Schema[][]) => {
      await dataProvider.update("drivingLicenseAuthorityForms", {
        id: drivingLicenseAuthorityForm.id,
        data: { pdfTemplate },
        previousData: drivingLicenseAuthorityForm,
      });
    },
    [drivingLicenseAuthorityForm],
  );

  if (!drivingLicenseAuthorityForm) {
    return <LoadingIndicator />;
  }

  return <PdfMeTemplateDialog {...dialogProps} record={drivingLicenseAuthorityForm} onSubmit={onSubmit} />;
}
